import { Component, OnInit } from '@angular/core';

declare var $: any;
declare var google: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  public static googleChartLibraryLoaded:boolean = false;

  constructor() {
    AppComponent.loadGoogleChartLibraryIfNecessary();
  }

  static loadGoogleChartLibraryIfNecessary() {
    if (!AppComponent.googleChartLibraryLoaded) {
      google.charts.load('current', {'packages':['corechart']});
      google.charts.setOnLoadCallback(function() {
        AppComponent.googleChartLibraryLoaded = true;
      });
    }
  }

  /* https://stackoverflow.com/a/37835780  */
  ngOnInit() {
    $(window).on('popstate', function() {
      $(".modal-backdrop").remove(); // remove modal backdrop if user navigates browser with a modal open.
      $(".swal-overlay").remove(); // remove swal modal backdrop if user navigates browser with a modal open.
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts